import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStyle } from 'react-native-style-utilities';

import { useResponsive } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Bottom safe area padding for reorder modals on compact screens. The modal's
 * native bottom edge leaves the footer CTAs on the home indicator, so the inset
 * is applied as padding instead.
 */
export const useReorderModalSafeAreaStyle = () => {
  const { currentBreakpoint } = useResponsive();
  const { bottom: safeAreaBottom } = useSafeAreaInsets();

  return useStyle(() => {
    if (!currentBreakpoint.isXS) {
      return;
    }

    return { paddingBottom: safeAreaBottom };
  }, [currentBreakpoint.isXS, safeAreaBottom]);
};
